import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export const useOtelSpans = (filters = {}, options = {}) => {
  const { autoRefresh = false } = options;

  return useQuery({
    queryKey: ['otel-spans', filters],
    queryFn: async () => {
      const params = {};
      if (filters.vendor) params.vendor = filters.vendor;
      if (filters.model) params.model = filters.model;
      if (filters.hours) params.hours = filters.hours;
      if (filters.limit) params.limit = filters.limit;
      if (filters.offset) params.offset = filters.offset;

      const { data } = await api.get('/api/otel/spans', { params });
      return data;
    },
    refetchInterval: autoRefresh ? 10000 : false, // Poll every 10s if auto-refresh
    staleTime: 5000,
  });
};

export const useOtelMetrics = (filters = {}, options = {}) => {
  const { autoRefresh = false } = options;

  return useQuery({
    queryKey: ['otel-metrics', filters],
    queryFn: async () => {
      const params = {};
      if (filters.hours) params.hours = filters.hours;
      if (filters.vendor) params.vendor = filters.vendor;

      const { data } = await api.get('/api/otel/metrics', { params });
      return data;
    },
    refetchInterval: autoRefresh ? 10000 : false,
    staleTime: 5000,
  });
};

export const useOtelComparison = (filters = {}, options = {}) => {
  const { autoRefresh = false } = options;

  return useQuery({
    queryKey: ['otel-comparison', filters],
    queryFn: async () => {
      const params = {};
      if (filters.hours) params.hours = filters.hours;

      const { data } = await api.get('/api/otel/comparison', { params });
      return data;
    },
    refetchInterval: autoRefresh ? 10000 : false,
    staleTime: 5000,
  });
};
